import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Login from '@/pages/Login';
import CreateSuperAdmin from '@/pages/CreateSuperAdmin';
import Dashboard from '@/pages/Dashboard';
import DeviceRegistration from '@/pages/DeviceRegistration';
import Components from '@/pages/Components';
import Users from '@/pages/Users';
import TankPercentageGraph from '@/pages/TankPercentageGraph';
import Alerts from '@/pages/Alerts';
import AdditionalSensors from '@/pages/AdditionalSensors';
import Automation from '@/pages/Automation';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import '@/App.css';

const ProtectedRoute = ({ children, requireSuperAdmin = false }) => {
  const { user, loading, isSuperAdmin } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireSuperAdmin && !isSuperAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Navigate to="/login" replace />} />
          <Route
            path="/create-aqua-super-admin"
            element={<CreateSuperAdmin />}
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/devices"
            element={
              <ProtectedRoute requireSuperAdmin={true}>
                <DeviceRegistration />
              </ProtectedRoute>
            }
          />
          <Route
            path="/components"
            element={
              <ProtectedRoute requireSuperAdmin={true}>
                <Components />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute requireSuperAdmin={true}>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/alerts"
            element={
              <ProtectedRoute>
                <Alerts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/additional-sensors"
            element={
              <ProtectedRoute>
                <AdditionalSensors />
              </ProtectedRoute>
            }
          />
          <Route
            path="/automation"
            element={
              <ProtectedRoute>
                <Automation />
              </ProtectedRoute>
            }
          />
          <Route path="/reports" element={<Navigate to="/dashboard" replace />} />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <TankPercentageGraph />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
